import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from "react-accessible-accordion";
import getCheckboxField from "../../fields/checkbox";
import getSelectField from "../../fields/select";
import getRadioField from "../../fields/radio";
import getFonts from "../../../Functions/config/fonts";
import { HexAlphaColorPicker, HexColorInput } from "react-colorful";

const Detail = ({
  widget,
  handleInputChange,
  toggleColorPicker,
  setColorsAndPreview,
}) => {
  const { rentvine } = widget.htmlData;
  const fontOptions = getFonts();

  const handleColorChange = (type) => async (color) => {
    await setColorsAndPreview("detail", type, color);
  };

  return (
    <div className="mjwi-acc-panel-wrapper">
      {/* Open in Separate Page */}
      <div className="mjwi-row">
        <div className="mjwi-col75">
          <label>Open in Separate Page</label>
        </div>
        <div className="mjwi-col25">
          {getCheckboxField(
            "detailOpenSeparate",
            rentvine.detail.detailOpenSeparate,
            handleInputChange
          )}
        </div>
      </div>

      {/* Layout Template Selection */}
      <div className="mjwi-row">
        <div className="mjwi-col33">
          <label>Layout</label>
        </div>
        <div className="mjwi-col66">
          <div className="mjwi-row mjwi-flex-end">
            <div className="mjwi-col25 mjwi-radio-svg">
              <label>
                {getRadioField(
                  "detailTemplate",
                  "full",
                  rentvine.detail.detailTemplate,
                  handleInputChange
                )}
                <svg
                  width="50px"
                  height="50px"
                  viewBox="0 0 24 24"
                  fill="#fff"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3 9H21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z"
                    stroke="#000000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </label>
            </div>
            <div className="mjwi-col25 mjwi-radio-svg">
              <label>
                {getRadioField(
                  "detailTemplate",
                  "half",
                  rentvine.detail.detailTemplate,
                  handleInputChange
                )}
                <svg
                  width="50px"
                  height="50px"
                  viewBox="0 0 24 24"
                  fill="#fff"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 3V21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z"
                    stroke="#000000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </label>
            </div>
          </div>
        </div>
      </div>

      {/* Section Background Color */}
      <div className="mjwi-row">
        <div className="mjwi-col50">
          <label>Background Color</label>
        </div>
        <div className="mjwi-col50 mjwi-clr-picker">
          <span
            className="clrPickerVal"
            onClick={toggleColorPicker}
            style={{ backgroundColor: rentvine.detail.detailSectionBg }}
          ></span>
          <HexAlphaColorPicker
            color={rentvine.detail.detailSectionBg}
            onChange={handleColorChange("detailSectionBg")}
            style={{ display: "none" }}
            className="mjwi-apfl-color-picker"
          />
          <HexColorInput
            color={rentvine.detail.detailSectionBg}
            onChange={handleColorChange("detailSectionBg")}
          />
        </div>
      </div>

      {/* Text Color */}
      <div className="mjwi-row">
        <div className="mjwi-col50">
          <label>Text Color</label>
        </div>
        <div className="mjwi-col50 mjwi-clr-picker">
          <span
            className="clrPickerVal"
            onClick={toggleColorPicker}
            style={{ backgroundColor: rentvine.detail.detailSectionTextColor }}
          ></span>
          <HexAlphaColorPicker
            color={rentvine.detail.detailSectionTextColor}
            onChange={handleColorChange("detailSectionTextColor")}
            style={{ display: "none" }}
            className="mjwi-apfl-color-picker"
          />
          <HexColorInput
            color={rentvine.detail.detailSectionTextColor}
            onChange={handleColorChange("detailSectionTextColor")}
          />
        </div>
      </div>

      {/* Font Family */}
      <div className="mjwi-row">
        <div className="mjwi-col33">
          <label>Font Family</label>
        </div>
        <div className="mjwi-col66">
          {getSelectField(
            "detailSectionFF",
            fontOptions,
            rentvine.detail.detailSectionFF,
            handleInputChange
          )}
        </div>
      </div>

      {/* Accordion for Address, Rent, Available Date, Phone, Buttons, etc. */}
      <Accordion allowZeroExpanded={true}>
        {/* Address Section */}
        <AccordionItem className="mjwi-sub-accordion">
          <AccordionItemHeading>
            <AccordionItemButton>Address</AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <div className="mjwi-acc-panel-wrapper">
              <div className="mjwi-row">
                <div className="mjwi-col25">
                  <label>
                    {getCheckboxField(
                      "detailAddress",
                      rentvine.detail.detailAddress,
                      handleInputChange
                    )}
                    Show
                  </label>
                </div>
                <div className="mjwi-col75">
                  {rentvine.detail.detailAddress === "on" && (
                    <div className="mjwi-row">
                      <div className="mjwi-col50 mjwi-row">
                        <label>Size</label>&nbsp;
                        <input
                          type="number"
                          name="detailAddressFontSize"
                          value={rentvine.detail.detailAddressFontSize}
                          onChange={handleInputChange}
                        />
                        &nbsp;px
                      </div>
                      <div className="mjwi-col33">
                        <label>
                          {getCheckboxField(
                            "detailAddressFontBold",
                            rentvine.detail.detailAddressFontBold,
                            handleInputChange
                          )}
                          Bold
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {rentvine.detail.detailAddress === "on" && (
                <>
                  <div className="mjwi-row">
                    <div className="mjwi-col50">
                      <label>Color</label>
                    </div>
                    <div className="mjwi-col50 mjwi-clr-picker">
                      <span
                        className="clrPickerVal"
                        onClick={toggleColorPicker}
                        style={{
                          backgroundColor: rentvine.detail.detailAddressColor,
                        }}
                      ></span>
                      <HexAlphaColorPicker
                        color={rentvine.detail.detailAddressColor}
                        onChange={handleColorChange("detailAddressColor")}
                        style={{ display: "none" }}
                        className="mjwi-apfl-color-picker"
                      />
                      <HexColorInput
                        color={rentvine.detail.detailAddressColor}
                        onChange={handleColorChange("detailAddressColor")}
                      />
                    </div>
                  </div>
                  <div className="mjwi-row">
                    <div className="mjwi-col33">
                      <label>Font Family</label>
                    </div>
                    <div className="mjwi-col66">
                      {getSelectField(
                        "detailAddressFontFamily",
                        fontOptions,
                        rentvine.detail.detailAddressFontFamily,
                        handleInputChange
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </AccordionItemPanel>
        </AccordionItem>

        {/* Rent Section */}
        <AccordionItem className="mjwi-sub-accordion">
          <AccordionItemHeading>
            <AccordionItemButton>Rent</AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <div className="mjwi-acc-panel-wrapper">
              <div className="mjwi-row">
                <div className="mjwi-col25">
                  <label>
                    {getCheckboxField(
                      "detailPrice",
                      rentvine.detail.detailPrice,
                      handleInputChange
                    )}
                    Show
                  </label>
                </div>
                <div className="mjwi-col75">
                  {rentvine.detail.detailPrice === "on" && (
                    <div className="mjwi-row">
                      <div className="mjwi-col50 mjwi-row">
                        <label>Size</label>&nbsp;
                        <input
                          type="number"
                          name="detailPriceFontSize"
                          value={rentvine.detail.detailPriceFontSize}
                          onChange={handleInputChange}
                        />
                        &nbsp;px
                      </div>
                      <div className="mjwi-col33">
                        <label>
                          {getCheckboxField(
                            "detailPriceFontBold",
                            rentvine.detail.detailPriceFontBold,
                            handleInputChange
                          )}
                          Bold
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {rentvine.detail.detailPrice === "on" && (
                <>
                  <div className="mjwi-row">
                    <div className="mjwi-col50">
                      <label>Color</label>
                    </div>
                    <div className="mjwi-col50 mjwi-clr-picker">
                      <span
                        className="clrPickerVal"
                        onClick={toggleColorPicker}
                        style={{
                          backgroundColor: rentvine.detail.detailPriceColor,
                        }}
                      ></span>
                      <HexAlphaColorPicker
                        color={rentvine.detail.detailPriceColor}
                        onChange={handleColorChange("detailPriceColor")}
                        style={{ display: "none" }}
                        className="mjwi-apfl-color-picker"
                      />
                      <HexColorInput
                        color={rentvine.detail.detailPriceColor}
                        onChange={handleColorChange("detailPriceColor")}
                      />
                    </div>
                  </div>
                  <div className="mjwi-row">
                    <div className="mjwi-col33">
                      <label>Font Family</label>
                    </div>
                    <div className="mjwi-col66">
                      {getSelectField(
                        "detailPriceFontFamily",
                        fontOptions,
                        rentvine.detail.detailPriceFontFamily,
                        handleInputChange
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </AccordionItemPanel>
        </AccordionItem>

        {/* Available Date Section */}
        <AccordionItem className="mjwi-sub-accordion">
          <AccordionItemHeading>
            <AccordionItemButton>Available Date</AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <div className="mjwi-acc-panel-wrapper">
              <div className="mjwi-row">
                <div className="mjwi-col25">
                  <label>
                    {getCheckboxField(
                      "detailAvailable",
                      rentvine.detail.detailAvailable,
                      handleInputChange
                    )}
                    Show
                  </label>
                </div>
                <div className="mjwi-col75">
                  {rentvine.detail.detailAvailable === "on" && (
                    <div className="mjwi-row">
                      <div className="mjwi-col50 mjwi-row">
                        <label>Size</label>&nbsp;
                        <input
                          type="number"
                          name="detailAvailableFontSize"
                          value={rentvine.detail.detailAvailableFontSize}
                          onChange={handleInputChange}
                        />
                        &nbsp;px
                      </div>
                      <div className="mjwi-col33">
                        <label>
                          {getCheckboxField(
                            "detailAvailableFontBold",
                            rentvine.detail.detailAvailableFontBold,
                            handleInputChange
                          )}
                          Bold
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {rentvine.detail.detailAvailable === "on" && (
                <>
                  <div className="mjwi-row">
                    <div className="mjwi-col50">
                      <label>Color</label>
                    </div>
                    <div className="mjwi-col50 mjwi-clr-picker">
                      <span
                        className="clrPickerVal"
                        onClick={toggleColorPicker}
                        style={{
                          backgroundColor: rentvine.detail.detailAvailableColor,
                        }}
                      ></span>
                      <HexAlphaColorPicker
                        color={rentvine.detail.detailAvailableColor}
                        onChange={handleColorChange("detailAvailableColor")}
                        style={{ display: "none" }}
                        className="mjwi-apfl-color-picker"
                      />
                      <HexColorInput
                        color={rentvine.detail.detailAvailableColor}
                        onChange={handleColorChange("detailAvailableColor")}
                      />
                    </div>
                  </div>
                  <div className="mjwi-row">
                    <div className="mjwi-col33">
                      <label>Font Family</label>
                    </div>
                    <div className="mjwi-col66">
                      {getSelectField(
                        "detailAvailableFontFamily",
                        fontOptions,
                        rentvine.detail.detailAvailableFontFamily,
                        handleInputChange
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </AccordionItemPanel>
        </AccordionItem>

        {/* Phone Section */}
        <AccordionItem className="mjwi-sub-accordion">
          <AccordionItemHeading>
            <AccordionItemButton>Phone</AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <div className="mjwi-acc-panel-wrapper">
              <div className="mjwi-row">
                <div className="mjwi-col25">
                  <label>
                    {getCheckboxField(
                      "detailPhone",
                      rentvine.detail.detailPhone,
                      handleInputChange
                    )}
                    Show
                  </label>
                </div>
                <div className="mjwi-col75">
                  {rentvine.detail.detailPhone === "on" && (
                    <div className="mjwi-row">
                      <div className="mjwi-col50 mjwi-row">
                        <label>Size</label>&nbsp;
                        <input
                          type="number"
                          name="detailPhoneFontSize"
                          value={rentvine.detail.detailPhoneFontSize}
                          onChange={handleInputChange}
                        />
                        &nbsp;px
                      </div>
                      <div className="mjwi-col33">
                        <label>
                          {getCheckboxField(
                            "detailPhoneFontBold",
                            rentvine.detail.detailPhoneFontBold,
                            handleInputChange
                          )}
                          Bold
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {rentvine.detail.detailPhone === "on" && (
                <>
                  <div className="mjwi-row">
                    <div className="mjwi-col50">
                      <label>Color</label>
                    </div>
                    <div className="mjwi-col50 mjwi-clr-picker">
                      <span
                        className="clrPickerVal"
                        onClick={toggleColorPicker}
                        style={{
                          backgroundColor: rentvine.detail.detailPhoneColor,
                        }}
                      ></span>
                      <HexAlphaColorPicker
                        color={rentvine.detail.detailPhoneColor}
                        onChange={handleColorChange("detailPhoneColor")}
                        style={{ display: "none" }}
                        className="mjwi-apfl-color-picker"
                      />
                      <HexColorInput
                        color={rentvine.detail.detailPhoneColor}
                        onChange={handleColorChange("detailPhoneColor")}
                      />
                    </div>
                  </div>
                  <div className="mjwi-row">
                    <div className="mjwi-col33">
                      <label>Font Family</label>
                    </div>
                    <div className="mjwi-col66">
                      {getSelectField(
                        "detailPhoneFontFamily",
                        fontOptions,
                        rentvine.detail.detailPhoneFontFamily,
                        handleInputChange
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </AccordionItemPanel>
        </AccordionItem>

        {/* Schedule Showing Button */}
        <AccordionItem className="mjwi-sub-accordion">
          <AccordionItemHeading>
            <AccordionItemButton>Schedule Showing Button</AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <div className="mjwi-acc-panel-wrapper">
              <div className="mjwi-row">
                <div className="mjwi-col25">
                  <label>
                    {getCheckboxField(
                      "detailShowingBtn",
                      rentvine.detail.detailShowingBtn,
                      handleInputChange
                    )}
                    Show
                  </label>
                </div>
                <div className="mjwi-col75">
                  {rentvine.detail.detailShowingBtn === "on" && (
                    <div className="mjwi-row">
                      <div className="mjwi-col50 mjwi-row">
                        <label>Size</label>&nbsp;
                        <input
                          type="number"
                          name="detailShowingFontSize"
                          value={rentvine.detail.detailShowingFontSize}
                          onChange={handleInputChange}
                        />
                        &nbsp;px
                      </div>
                      <div className="mjwi-col33">
                        <label>
                          {getCheckboxField(
                            "detailShowingFontBold",
                            rentvine.detail.detailShowingFontBold,
                            handleInputChange
                          )}
                          Bold
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {rentvine.detail.detailShowingBtn === "on" && (
                <>
                  <div className="mjwi-row">
                    <div className="mjwi-col50">
                      <label>Color</label>
                    </div>
                    <div className="mjwi-col50 mjwi-clr-picker">
                      <span
                        className="clrPickerVal"
                        onClick={toggleColorPicker}
                        style={{
                          backgroundColor: rentvine.detail.detailShowingColor,
                        }}
                      ></span>
                      <HexAlphaColorPicker
                        color={rentvine.detail.detailShowingColor}
                        onChange={handleColorChange("detailShowingColor")}
                        style={{ display: "none" }}
                        className="mjwi-apfl-color-picker"
                      />
                      <HexColorInput
                        color={rentvine.detail.detailShowingColor}
                        onChange={handleColorChange("detailShowingColor")}
                      />
                    </div>
                  </div>
                  <div className="mjwi-row">
                    <div className="mjwi-col50">
                      <label>Background Color</label>
                    </div>
                    <div className="mjwi-col50 mjwi-clr-picker">
                      <span
                        className="clrPickerVal"
                        onClick={toggleColorPicker}
                        style={{
                          backgroundColor: rentvine.detail.detailShowingBg,
                        }}
                      ></span>
                      <HexAlphaColorPicker
                        color={rentvine.detail.detailShowingBg}
                        onChange={handleColorChange("detailShowingBg")}
                        style={{ display: "none" }}
                        className="mjwi-apfl-color-picker"
                      />
                      <HexColorInput
                        color={rentvine.detail.detailShowingBg}
                        onChange={handleColorChange("detailShowingBg")}
                      />
                    </div>
                  </div>
                  <div className="mjwi-row">
                    <div className="mjwi-col33">
                      <label>Font Family</label>
                    </div>
                    <div className="mjwi-col66">
                      {getSelectField(
                        "detailShowingFontFamily",
                        fontOptions,
                        rentvine.detail.detailShowingFontFamily,
                        handleInputChange
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </AccordionItemPanel>
        </AccordionItem>

        {/* Apply Button */}
        <AccordionItem className="mjwi-sub-accordion">
          <AccordionItemHeading>
            <AccordionItemButton>Apply Button</AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <div className="mjwi-acc-panel-wrapper">
              <div className="mjwi-row">
                <div className="mjwi-col25">
                  <label>
                    {getCheckboxField(
                      "detailApplyBtn",
                      rentvine.detail.detailApplyBtn,
                      handleInputChange
                    )}
                    Show
                  </label>
                </div>
                <div className="mjwi-col75">
                  {rentvine.detail.detailApplyBtn === "on" && (
                    <div className="mjwi-row">
                      <div className="mjwi-col50 mjwi-row">
                        <label>Size</label>&nbsp;
                        <input
                          type="number"
                          name="detailApplyFontSize"
                          value={rentvine.detail.detailApplyFontSize}
                          onChange={handleInputChange}
                        />
                        &nbsp;px
                      </div>
                      <div className="mjwi-col33">
                        <label>
                          {getCheckboxField(
                            "detailApplyFontBold",
                            rentvine.detail.detailApplyFontBold,
                            handleInputChange
                          )}
                          Bold
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {rentvine.detail.detailApplyBtn === "on" && (
                <>
                  <div className="mjwi-row">
                    <div className="mjwi-col50">
                      <label>Color</label>
                    </div>
                    <div className="mjwi-col50 mjwi-clr-picker">
                      <span
                        className="clrPickerVal"
                        onClick={toggleColorPicker}
                        style={{
                          backgroundColor: rentvine.detail.detailApplyColor,
                        }}
                      ></span>
                      <HexAlphaColorPicker
                        color={rentvine.detail.detailApplyColor}
                        onChange={handleColorChange("detailApplyColor")}
                        style={{ display: "none" }}
                        className="mjwi-apfl-color-picker"
                      />
                      <HexColorInput
                        color={rentvine.detail.detailApplyColor}
                        onChange={handleColorChange("detailApplyColor")}
                      />
                    </div>
                  </div>
                  <div className="mjwi-row">
                    <div className="mjwi-col50">
                      <label>Background Color</label>
                    </div>
                    <div className="mjwi-col50 mjwi-clr-picker">
                      <span
                        className="clrPickerVal"
                        onClick={toggleColorPicker}
                        style={{
                          backgroundColor: rentvine.detail.detailApplyBg,
                        }}
                      ></span>
                      <HexAlphaColorPicker
                        color={rentvine.detail.detailApplyBg}
                        onChange={handleColorChange("detailApplyBg")}
                        style={{ display: "none" }}
                        className="mjwi-apfl-color-picker"
                      />
                      <HexColorInput
                        color={rentvine.detail.detailApplyBg}
                        onChange={handleColorChange("detailApplyBg")}
                      />
                    </div>
                  </div>
                  <div className="mjwi-row">
                    <div className="mjwi-col33">
                      <label>Font Family</label>
                    </div>
                    <div className="mjwi-col66">
                      {getSelectField(
                        "detailApplyFontFamily",
                        fontOptions,
                        rentvine.detail.detailApplyFontFamily,
                        handleInputChange
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </AccordionItemPanel>
        </AccordionItem>

        {/* Contact Button */}
        <AccordionItem className="mjwi-sub-accordion">
          <AccordionItemHeading>
            <AccordionItemButton>Contact Button</AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <div className="mjwi-acc-panel-wrapper">
              <div className="mjwi-row">
                <div className="mjwi-col25">
                  <label>
                    {getCheckboxField(
                      "detailContactBtn",
                      rentvine.detail.detailContactBtn,
                      handleInputChange
                    )}
                    Show
                  </label>
                </div>
                <div className="mjwi-col75">
                  {rentvine.detail.detailContactBtn === "on" && (
                    <div className="mjwi-row">
                      <div className="mjwi-col50 mjwi-row">
                        <label>Size</label>&nbsp;
                        <input
                          type="number"
                          name="detailContactFontSize"
                          value={rentvine.detail.detailContactFontSize}
                          onChange={handleInputChange}
                        />
                        &nbsp;px
                      </div>
                      <div className="mjwi-col33">
                        <label>
                          {getCheckboxField(
                            "detailContactFontBold",
                            rentvine.detail.detailContactFontBold,
                            handleInputChange
                          )}
                          Bold
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {rentvine.detail.detailContactBtn === "on" && (
                <>
                  <div className="mjwi-row">
                    <div className="mjwi-col50">
                      <label>Color</label>
                    </div>
                    <div className="mjwi-col50 mjwi-clr-picker">
                      <span
                        className="clrPickerVal"
                        onClick={toggleColorPicker}
                        style={{
                          backgroundColor: rentvine.detail.detailContactColor,
                        }}
                      ></span>
                      <HexAlphaColorPicker
                        color={rentvine.detail.detailContactColor}
                        onChange={handleColorChange("detailContactColor")}
                        style={{ display: "none" }}
                        className="mjwi-apfl-color-picker"
                      />
                      <HexColorInput
                        color={rentvine.detail.detailContactColor}
                        onChange={handleColorChange("detailContactColor")}
                      />
                    </div>
                  </div>
                  <div className="mjwi-row">
                    <div className="mjwi-col50">
                      <label>Background Color</label>
                    </div>
                    <div className="mjwi-col50 mjwi-clr-picker">
                      <span
                        className="clrPickerVal"
                        onClick={toggleColorPicker}
                        style={{
                          backgroundColor: rentvine.detail.detailContactBg,
                        }}
                      ></span>
                      <HexAlphaColorPicker
                        color={rentvine.detail.detailContactBg}
                        onChange={handleColorChange("detailContactBg")}
                        style={{ display: "none" }}
                        className="mjwi-apfl-color-picker"
                      />
                      <HexColorInput
                        color={rentvine.detail.detailContactBg}
                        onChange={handleColorChange("detailContactBg")}
                      />
                    </div>
                  </div>
                  <div className="mjwi-row">
                    <div className="mjwi-col33">
                      <label>Font Family</label>
                    </div>
                    <div className="mjwi-col66">
                      {getSelectField(
                        "detailContactFontFamily",
                        fontOptions,
                        rentvine.detail.detailContactFontFamily,
                        handleInputChange
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default Detail;
